import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'HyperJump',
  description:
    'The most popular AMM on BSC by user count! Earn ALLOY through yield farming or win it in the Lottery, then stake it in Mech Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by HyperJump), NFTs, and more, on a platform you can trust.',
  image: 'https://hyperjump.app/hyperjump-preview.jpg',
}

export const getCustomMeta = (path: string): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${'Home'} | ${'HyperJump'}`,
      }
    case '/competition':
      return {
        title: `${'Trading Battle'} | ${'HyperJump'}`,
      }
    case '/prediction':
      return {
        title: `${'Prediction'} | ${'HyperJump'}`,
      }
    case '/farms':
      return {
        title: `${'Farms'} | ${'HyperJump'}`,
      }
    case '/pools':
      return {
        title: `${'Pools'} | ${'HyperJumpJump'}`,
      }
    case '/lottery':
      return {
        title: `${'Lottery'} | ${'HyperJump'}`,
      }
    case '/collectibles':
      return {
        title: `${'Collectibles'} | ${'HyperJump'}`,
      }
    case '/ifo':
      return {
        title: `${'Initial Farm Offering'} | ${'HyperJump'}`,
      }
    case '/teams':
      return {
        title: `${'Leaderboard'} | ${'HyperJump'}`,
      }
    case '/profile/tasks':
      return {
        title: `${'Task Center'} | ${'HyperJump'}`,
      }
    case '/profile':
      return {
        title: `${'Your Profile'} | ${'HyperJump'}`,
      }
    default:
      return null
  }
}
